export default __webpack_public_path__ + "static/media/trending02.f38b60f3.jpg";